'use client'

import { styled } from 'styled-components'

export const StyledDestinationFromPriceSlide = styled.div<{ $position: string; $orientation: string; }>`
    position: relative;
    height: 100dvh;
    aspect-ratio: ${props => props.$orientation == "horizontal" ? "16/9" : "9/16"};

    margin-inline: auto;
    padding-inline: 1rem;
    box-sizing: border-box;

    * {
        z-index: 2;
        position: relative;
    }

    img {
        z-index: 1;
    }

    ${({ $orientation, $position }) => $orientation == "horizontal" ? `
        margin-inline: 0;
        padding-left: 2.4rem;

        >div {
            margin-left: ${$position == 'left' ? "0" : "auto"};
            width: 50%;
        }
    ` : ''}
`

export const StyledH1 = styled.h1<{ $color: string; $shade?: string; $orientation: string; }>`
    padding-top: 2rem;
    font-size: 1.8rem;
    color: ${props => props.$color};
    ${props => props.$shade ? `text-shadow: ${props.$shade} 1px 1px;` : ""}
    ${({ $orientation }) => $orientation == "horizontal" ? `
        padding-top: 2rem;
        font-size: 2.6rem;
        padding-top: 1rem;
    ` : ''}
`

export const StyledH2 = styled.h2<{ $color: string; $shade?: string; $position: string; $orientation: string }>`
    display: inline-block;
    background-color: #e40227;
    margin-left: ${({ $position, $orientation }) => $position !== "right" ? ($orientation == "horizontal" ? "-2.4rem" : "-1rem") : "0"};
    padding: 0.2rem 1rem;
    margin-bottom: 1rem;
    position: relative;
    font-size: 2.1rem;
    color: ${props => props.$color};
    ${props => props.$shade ? `text-shadow: ${props.$shade} 1px 1px;` : ""}

    ${({ $orientation, $position, $shade }) => $orientation === "horizontal" ? `
        font-size: 3.6rem;
        margin-left: ${$position === 'left' ? "-2.4rem" : "0"};
        padding: 0.8rem 2.4rem;
        margin-bottom: 1.4rem;
        ${$shade ? `text-shadow: ${$shade} 2px 2px;` : ""}
    ` : ''}

    &:after {
        width: calc(100% - 1rem);
        bottom: -4px;
        height: 4px;
        display: block;
        content: "";
        background-color: white;
        z-index: 1;
        position: absolute;

        ${({ $orientation, $position }) => $orientation === "horizontal" ? `
            width: ${$position === 'left' ? "calc(100% - 2.4rem)" : "100%"};
            margin-left: ${$position === 'left' ? "0" : "-2.4rem"};
            bottom: -0.4rem;
            height: 0.4rem;
        ` : ''}
    }
`

export const DestinationRowDestination = styled.span<{ $color: string; $shade?: string; $orientation: string }>`
    color: ${props => props.$color};
    ${props => props.$shade ? `text-shadow: ${props.$shade} 1px 1px;` : ""}
    font-size: 0.75rem;
    line-height: 1.1rem;

    ${({ $orientation }) => $orientation == "horizontal" ? `
        font-size: 1.3rem;
        line-height: 2rem;
    ` : ''}
`

export const DestinationRowPrice = styled.span<{ $color: string; $shade?: string; $orientation: string }>`
    color: ${props => props.$color};
    ${props => props.$shade ? `text-shadow: ${props.$shade} 1px 1px;` : ""}
    font-size: 1.1rem;
    line-height: 1.1rem;
    font-weight: 700;
    text-align: right;

    ${({ $orientation }) => $orientation == "horizontal" ? `
        font-size: 1.5rem;
        line-height: 1.6rem;
    ` : ''}
`

export const DestinationPriceRowGrid = styled.div<{ $orientation: string, $position: string }>`
    display: grid;
    grid-template-rows: 1fr auto;
    grid-template-columns: auto auto;
    column-gap: 1rem;
    row-gap: 0.2rem;
    margin-left: ${props => props.$position == 'left' ? '-0.5rem' : '0'};

    justify-content: space-between;
    background-color: rgba(255, 255, 255, 0.4);
    margin-bottom: 1rem;
    padding: 0.2rem 0.5rem;
    border-radius: 5px;

    ${({ $orientation }) => $orientation == "horizontal" ? `
        margin-bottom: 1.2rem;
    ` : ''}

    &:last-of-type {
        margin-bottom: 0;
    }
`

export const PlaneDiv = styled.div`
    position: relative;
    height: 1.5rem;
    aspect-ratio: 9 / 6;
`
